import { useContext } from "react";
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from "@mui/material";
import { applicationContext } from "helpers/services";
import { dashboardContext } from "./DashboardContext";
import ClickableAssignee from "./ClickableAssignee";
import { LocalizationIds } from "helpers/Localizations";
import { useIntl } from 'react-intl';

let ByAssigneeDashboard = () => {
    let { formatMessage } = useIntl();
    let { simecUsers } = useContext(applicationContext)
    let { byAssigneeDashboard } = useContext(dashboardContext)

    return (
        <>
            <>
                <Typography variant="h5">{formatMessage({ id: LocalizationIds.DashboardByAssignee })}</Typography>

                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>{formatMessage({ id: LocalizationIds.User })}</TableCell>
                            <TableCell align="right"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {byAssigneeDashboard
                            .map((x, i) =>
                                <TableRow key={i} hover>
                                    <TableCell component="th" scope="row">
                                        {x.email === 'null'
                                            ? formatMessage({ id: LocalizationIds.Unassigned })
                                            : simecUsers.getValueByKey(x.email, 'email', 'fullName') ?? x.email
                                        }
                                    </TableCell>
                                    <TableCell align="right">
                                        <ClickableAssignee value={x.count} assignee={x.email} />
                                    </TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                    {byAssigneeDashboard.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={2}><i>{formatMessage({ id: LocalizationIds.NoResults })}</i></TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            </>
        </>)
}
export default ByAssigneeDashboard;
